// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"59":"9dfe2d19","579":"820fa2dd"}[chunkId] + ".css";
};